
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"157","height":"181","viewBox":"0 0 157 181","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#7356EC"}},[_c('path',{attrs:{"d":"M80.62 123.883V77.5H46.383v46.383H0v34.235h46.384V204.5H80.62v-46.382H127v-34.235H80.62zM128.148 29.352V.5h-21.295v28.852H78v21.296h28.853V79.5h21.295V50.648H157V29.352h-28.852z"}})])])
          )
        }
      }
    